import React from 'react';
import { locationData } from '../mockData';
import { MapPin } from 'lucide-react';

const Location = () => {
  return (
    <section id="herzogpark" className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Lage
          </h2>
          <div className="flex items-center justify-center space-x-2 text-gray-600">
            <MapPin size={20} />
            <p className="text-lg">{locationData.address}</p>
          </div>
        </div>

        {/* Star Rating */}
        <div className="text-center mb-12">
          <div className="text-4xl md:text-5xl tracking-widest text-gray-800">
            ★ ★ ★ ★ ★
          </div>
        </div>

        {/* Map Embed */}
        <div className="aspect-video w-full overflow-hidden rounded-sm shadow-lg">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2662!2d11.6058!3d48.1541!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s!2sMauerkircherstra%C3%9Fe%20118%2C%2081679%20M%C3%BCnchen!5e0!3m2!1sde!2sde"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Herzogparksuiten Location"
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default Location;